import React from 'react';
import { useSecurityAlerts } from '../hooks/use-security-alerts.js';
import SecurityAlertsPageView from './security-alerts-page-view.jsx';

function SecurityAlertsPageContainer() {
  const state = useSecurityAlerts();

  return <SecurityAlertsPageView {...state} />;
}

export default SecurityAlertsPageContainer;
